var map = {
	"./ic-buy-x-get-y.png": "OBSu",
	"./ic-gift.png": "bWre",
	"./ic-loyalty.png": "r/Ua",
	"./ic-minimum-purchase.png": "6MHu",
	"./ic-set-menu.png": "uIiS"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Fee4";